import React, { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import NavTabs from './components/NavTabs'
import Footer from './components/Footer'
import ToolsSection from './components/ToolsSection'
import OnlineToolsSection from './components/OnlineToolsSection'
import BooksSection from './components/BooksSection'
import MoviesSection from './components/MoviesSection'
import VideosSection from './components/VideosSection'
import BooksTalkSection from './pages/BooksTalkSection'
import BooksTalkDetail from './pages/BooksTalkDetail'
import PrivacyPage from './pages/PrivacyPage'
import UserAgreementPage from './pages/UserAgreementPage'

function HomePage() {
  const [activeTab, setActiveTab] = useState('tools')

  const renderSection = () => {
    switch (activeTab) {
      case 'tools':
        return <ToolsSection />
      case 'online':
        return <OnlineToolsSection />
      case 'books':
        return <BooksSection />
      case 'movies':
        return <MoviesSection />
      case 'videos':
        return <VideosSection />
      case 'books-talk':
        return <BooksTalkSection />
      default:
        return <ToolsSection />
    }
  }

  return (
    <div className="app">
      <div id="stars"></div>
      <div className="wrapper">
        <Header />
        <NavTabs activeTab={activeTab} onTabChange={setActiveTab} />
        {renderSection()}
        <Footer />
      </div>
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/books-talk/:id" element={<BooksTalkDetail />} />
        <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/user-agreement" element={<UserAgreementPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
